import { useMemo, useState } from "react";
import { getCurrentMagentoClient } from "@jti/magento";
import { useConfig } from "@jti/ui";
export const useXSellingPopup = (cartId) => {
    const [isXSellingAllowedFromMagento, setIsXSellingAllowedFromMagento] = useState(false);
    const { isXSellingPopupEnabled, xSellingPopupTitle, xSellingPopupSubtitle, xSellingPopupDescription, xSellingPopupImage, xSellingPopupImageAlt, xSellingPopupConfirmButtonText, xSellingPopupCancelButtonText, xSellingPopupConfirmRedirectUrl, } = useConfig();
    const isEnabledInBuilder = isXSellingPopupEnabled ?? false;
    const xSellingPopupContent = useMemo(() => ({
        title: xSellingPopupTitle,
        subtitle: xSellingPopupSubtitle,
        description: xSellingPopupDescription,
        image: xSellingPopupImage,
        imageAlt: xSellingPopupImageAlt,
        confirmButtonText: xSellingPopupConfirmButtonText,
        cancelButtonText: xSellingPopupCancelButtonText,
        confirmRedirectUrl: xSellingPopupConfirmRedirectUrl,
    }), [
        xSellingPopupTitle,
        xSellingPopupSubtitle,
        xSellingPopupDescription,
        xSellingPopupImage,
        xSellingPopupImageAlt,
        xSellingPopupConfirmButtonText,
        xSellingPopupCancelButtonText,
        xSellingPopupConfirmRedirectUrl,
    ]);
    const checkMagentoFlag = async () => {
        if (!cartId || !isEnabledInBuilder)
            return false;
        const client = getCurrentMagentoClient();
        try {
            const response = await client.getXSellingPopup(cartId);
            const isEnabled = Boolean(response.cart.xselling_popup);
            setIsXSellingAllowedFromMagento(isEnabled);
            return isEnabled;
        }
        catch (err) {
            console.error("useXSellingPopup: Error fetching xselling_popup:", err);
            return false;
        }
    };
    return {
        isXSellingPopupEnabledFromBuilder: isEnabledInBuilder,
        xSellingPopupContent,
        isXSellingAllowedFromMagento,
        triggerMagentoCheck: checkMagentoFlag,
        closePopup: () => setIsXSellingAllowedFromMagento(false),
    };
};
//# sourceMappingURL=useXSellingPopup.js.map